// Inline stroke icons (same style as the mockups). Decorative: aria-hidden.
type P = { size?: number };
const base = (size: number) => ({
  width: size, height: size, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor',
  strokeWidth: 1.5, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const, 'aria-hidden': true,
});

export const CheckIcon = ({ size = 14 }: P) => <svg {...base(size)}><path d="M20 6 9 17l-5-5" /></svg>;
export const LockIcon = ({ size = 32 }: P) => (
  <svg {...base(size)}><rect width="18" height="11" x="3" y="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>
);
export const FolderIcon = ({ size = 16 }: P) => (
  <svg {...base(size)}><path d="M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z" /></svg>
);
export const DownloadIcon = ({ size = 16 }: P) => (
  <svg {...base(size)}><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><path d="m7 10 5 5 5-5" /><path d="M12 15V3" /></svg>
);
export const AlertIcon = ({ size = 32 }: P) => (
  <svg {...base(size)}><circle cx="12" cy="12" r="10" /><path d="M12 8v4" /><path d="M12 16h.01" /></svg>
);
export const PrIcon = ({ size = 16 }: P) => (
  <svg {...base(size)}><circle cx="6" cy="6" r="3" /><circle cx="18" cy="18" r="3" /><path d="M6 9v12" /><path d="M13 6h3a2 2 0 0 1 2 2v7" /></svg>
);
export const CommentIcon = ({ size = 14 }: P) => (
  <svg {...base(size)}><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></svg>
);
export const ExternalIcon = ({ size = 14 }: P) => (
  <svg {...base(size)}><path d="M15 3h6v6" /><path d="M10 14 21 3" /><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" /></svg>
);
export const ChevronUpIcon = ({ size = 16 }: P) => <svg {...base(size)}><path d="m18 15-6-6-6 6" /></svg>;
export const ChevronDownIcon = ({ size = 16 }: P) => <svg {...base(size)}><path d="m6 9 6 6 6-6" /></svg>;
export const CloseIcon = ({ size = 16 }: P) => <svg {...base(size)}><path d="M18 6 6 18" /><path d="m6 6 12 12" /></svg>;
